


























import { Component, Prop, Vue } from "vue-property-decorator";
import { InfoConfigDifference } from "@/data/models/InfoConfigAdministration";
import { groupDifferences } from "@/utils/InfoConfigAdministration";
import { optionNumber } from "@/utils/BeschreibungFile";

/**
 * The differences between two Beschreibung versions, by section. A changed option (an index that now
 * names something else) is marked: harmless for the new version, but it is what the author must mean.
 */
@Component
export default class InfoConfigDifferenceListComponent extends Vue {
  @Prop({ required: true })
  differences!: InfoConfigDifference[];

  get grouped() {
    return groupDifferences(this.differences);
  }

  describe(item: InfoConfigDifference): string {
    return this.$t(`admin.infoConfig.differences.${item.kind}`, [
      item.code ?? "",
      // IRES Cloud counts from 0, as a stored answer does; shown as the number references use.
      item.index === null ? "" : String(optionNumber(item.index)),
      item.before ?? "",
      item.after ?? "",
    ]).toString();
  }
}
